import SocialBar, { ISocialBarProps, ISocialIconProps } from './SocialBar';
export { SocialBar };
export type { ISocialBarProps, ISocialIconProps };
export default SocialBar;
